module.exports = __webpack_public_path__ + "src/img/turnRight.76ab7845.svg";